import isNil from 'lodash/isNil'

const buildArray = (sectionFunc, content) => {
  return content.map(sectionFunc)
}

export const buildCover = (contentStructureData, template, id) => {
  const obj = {
  image: {
      url: template?.sections?.hero?.backgroundImage,
      type: 'banner',
      orientation: template?.sections?.hero?.orientation
    },
  title: {
    content: template?.sections?.hero?.title,
    max_tokens: contentStructureData?.blocks?.cover?.title?.maxOutputTokens,
  },
  button1: {
    content: template?.sections?.hero?.ctaText,
    max_tokens: contentStructureData?.blocks?.cover?.button1text?.maxOutputTokens
  },
  shortDescription: {
    content: template?.sections?.hero?.subtitle,
    max_tokens: contentStructureData?.blocks?.cover?.shortDescription?.maxOutputTokens
  },
  subtitle: {
    content: template?.sections?.hero?.subtitle2,
    max_tokens: contentStructureData?.blocks?.cover?.shortDescription?.maxOutputTokens
  }
}
if (!isNil(contentStructureData?.blocks?.cover?.button2text)) {
  obj.button2 = {
    content: contentStructureData?.blocks?.cover?.button2text?.content,
    max_tokens: contentStructureData?.blocks?.cover?.button2text?.maxOutputTokens
  }
}
if (id === '23210ee7-ef96-40f7-9e34-52fd9385e5cd' || id === '043808e9-5440-4359-a5e0-c82e08dd1cca') {
  return { elements: [obj, obj] }
}
return obj
}

export const buildFeature = (content) => ({
  title: {
    content: content.title,
    maxOutputTokens: 3
  },
  shortDescription: {
    content: content.shortDescription,
    maxOutputTokens: 10
  }
})

export const buildFeautres = (content) => ({
  blockHeader: content.blockHeader,
  elements: buildArray(buildFeature, content.elements)
})

export const buildCallToAction1 = (content) => ({
  blockHeader: content.blockHeader,
  title: {
    content: content.title,
    maxOutputTokens: 4,
    image_tag: null
  },
  shortDescription: {
    content: content.shortDescription,
    maxOutputTokens: 10
  },
  button: content.button
})

export const buildAboutUs = (content) => ({
  title: {
    content: content.title,
    maxOutputTokens: 5,
    image_tag: 'portrait'
  },
  shortDescription: {
    content: content.shortDescription,
    maxOutputTokens: 10
  }
})

export const buildTestimonial = (content) => ({
  review: {
    content: content.review,
    maxOutputTokens: 25
  },
  fullName: {
    content: content.fullName,
    maxOutputTokens: 2
  }
})

export const buildTestimonials = (content) => ({
  elements: buildArray(buildTestimonial, content.elements)
})

export const buildCallToAction2 = (content) => ({
  header: {
    content: content.header
  },
  title: {
    content: content.title,
    image_tag: content.image_tag
  },
  shortDescription: {
    content: content.shortDescription,
    maxOutputTokens: 10
  }
})

// export const buildContact = (content) => ({})

export const buildTheme = (muiTheme) => ({
  title: muiTheme.title,
  templateIndex: muiTheme.templateIndex,
  colorThemesV2: muiTheme.colorThemesV2,
  styles: {
    preColor: {
      brand: muiTheme.palette.primary.main,
      altBrand: muiTheme.palette.secondary.main,
      text: muiTheme.palette.textColor,
      textAlt: muiTheme.palette.backgroundColor,
      complementary: muiTheme.palette.complementary
    }
  }
})

export const buildThemeFromTemplate = (selectedPalette) => {
const title = selectedPalette?.title?.toLowerCase();

const formattedTitle = title && (title.includes('custom') || title.includes('default'))
  ? 'custom'
  : selectedPalette?.title;
return {
    "title": formattedTitle,
    "templateIndex": selectedPalette?.templateIndex,
    "colorThemesV2": true,
    "styles": selectedPalette?.styles
  }
}

export const buildTypography = (template) => {
return {
  fontFamily: template?.theme?.typography?.fontFamily,
  headingFont: {
    fontFamily: template?.theme?.typography?.fontFamily
  },
  textFont: {
    fontFamily: template?.theme?.typography?.secondaryFont?.fontFamily
  }
}
}

/**
 * Grid sitewizard stores cover via transformCoverToElements:
 * [{ image: {...} }, { title: {...} }, ...].
 * Legacy / duplicate-slide format uses cover.elements[0] as one object with title, button1, image, etc.
 */
const normalizeCoverForParse = (cover) => {
  if (!cover?.elements?.length) return cover
  const first = cover.elements[0]
  if (first?.title != null && first?.button1 != null) {
    return first
  }
  const merged = {}
  for (const el of cover.elements) {
    if (!el || typeof el !== 'object') continue
    const keys = Object.keys(el)
    if (keys.length === 1) {
      merged[keys[0]] = el[keys[0]]
    } else {
      Object.assign(merged, el)
    }
  }
  return Object.keys(merged).length > 0 ? merged : first
}

export const parseBlocksFromSiteplus = (blocks, contentStructureData = {}) => {
  const { header, cover } = blocks

  // Ensure contentStructureData is initialized with blocks if not already present
  if (!contentStructureData.blocks) {
    contentStructureData.blocks = {};
  }

  if (!contentStructureData.blocks.header) {
    contentStructureData.blocks.header = {};
  }

  if (!contentStructureData.blocks.cover) {
    contentStructureData.blocks.cover = {};
  }
  
  if (!contentStructureData.blocks.features) {
    contentStructureData.blocks.features = {};
  }
  
  contentStructureData.blocks.header.title = {
    content: header?.title?.content,
    maxOutputTokens: header?.title?.max_tokens
  }

  const getCoverData = (_cover) => {
    if (!_cover || typeof _cover !== 'object') {
      return contentStructureData.blocks.cover
    }
    const coverOut = {}
    coverOut.title = {
      content: _cover.title?.content,
      maxOutputTokens: _cover.title?.max_tokens
    };
    
    coverOut.button1text = {
      content: _cover.button1?.content,
      maxOutputTokens: _cover.button1?.max_tokens
    };
  
    coverOut.shortDescription = {
      content: _cover.shortDescription?.content,
      maxOutputTokens: _cover.shortDescription?.max_tokens
    };
  
    coverOut.subtitle = {
      content: _cover.subtitle?.content,
      maxOutputTokens: _cover.subtitle?.max_tokens
    };
  
    coverOut.image = {
      url: _cover.image?.url,
      type: _cover.image?.type,
      orientation: _cover.image?.orientation
    };

    return coverOut
  }

  if (cover?.elements) {
    contentStructureData.blocks.cover = getCoverData(normalizeCoverForParse(cover))
  } else if (cover) {
    contentStructureData.blocks.cover = getCoverData(cover)
  }

  return contentStructureData;
};